import React from "react";

const Vvladvantage = () => {
  return (
    <div className="how_it_work pt-50 pb-45">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="section_title text_center mb-60 mt-3">
             
              <div className="section_main_title">
                <h2>Advantages of  <span>Voice Verification</span> 
                </h2>
              </div>
              <div className="em_bar">
                <div className="em_bar_bg"></div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          {/* Step 1 */}
          <div className="col-lg-4 col-md-6 col-sm-12">
            <div className="single_it_work mb-4">
              <div className="single_it_work_content pl-2 pr-2">
                <div className="single_it_work_content_list pb-5">
                 <img src="assets/images/icon/Process1.svg" alt="confirmed interest"/>
                </div>
                <div className="single_work_content_title pb-2">
                  <h4> Confirmed Interest </h4>
                </div>
                <div className="single_it_work_content_text pt-1">
                  <p>
                  Engage exclusively with prospects who have validated their <a href="https://proplusdata.co/intent-data">intent</a>  through direct dialogue, paving the way for impactful outreach.  


                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Step 2 */}
          <div className="col-lg-4 col-md-6 col-sm-12">
            <div className="single_it_work mb-4">
              <div className="single_it_work_content pl-2 pr-2">
                <div className="single_it_work_content_list pb-5">
                <img src="assets/images/icon/Process2.svg" alt="minimized risk"/>
                </div>
                <div className="single_work_content_title pb-2">
                  <h4> Minimized Risk 
 
                  </h4>
                </div>
                <div className="single_it_work_content_text pt-1">
                  <p>
                  Eliminate unreliable or outdated <a href="https://proplusdata.co/contact-data">contacts</a>  early, safeguarding resources and maintaining campaign effectiveness.  

                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Step 3 */}
          <div className="col-lg-4 col-md-6 col-sm-12">
            <div className="single_it_work mb-4">
              <div className="single_it_work_content pl-2 pr-2">
                <div className="single_it_work_content_list three pb-5">
                <img src="assets/images/icon/Process3.svg" alt="enhanced dialogue"/>
                </div>
                <div className="single_work_content_title pb-2">
                  <h4>Enhanced Dialogue  

                  </h4>
                </div>
                <div className="single_it_work_content_text pt-1">
                  <p>
                  Begin conversations with leads already familiar with your value proposition, fostering warmer, more productive exchanges. 


                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Vvladvantage;
